import React, { useEffect } from "react";
import styles from "../../../GiveawayDetails/GiveawayDetails.module.css";
import { TimeDisplay } from "../../../../../../../utils/TimeDisplay";
import { GiveawayActive, GiveawayArchieve } from "../../../../types";
import dreamcoinLogo from "/DC_coin.svg";
import star from "/tgstar.svg";
import usersLogo from "/usersLogo.svg";
import couponLogo from "/couponLogo.svg";

interface ActiveGiveawayInfoProps {
  giveaway: GiveawayActive | GiveawayArchieve;
  handleExpired: () => void;
  handleOpenDCModal: () => void;
  handleOpenStarModal: () => void;
  tg: any;
}

const ActiveGiveawayInfo: React.FC<ActiveGiveawayInfoProps> = ({
  giveaway,
  handleExpired,
  handleOpenDCModal,
  handleOpenStarModal,
  tg,
}) => {
  return (
    <div className={styles.infoContainer}>
      <div className={styles.timeContainer}>
        <TimeDisplay endDate={giveaway.end_date} format="detail">
          {(timeDetails, isExpired) => {
            useEffect(() => {
              if (isExpired) {
                handleExpired();
              }
            }, [isExpired]);

            const {
              days = 0,
              hours = 0,
              minutes = 0,
              seconds = 0,
            } = typeof timeDetails === "string" ? {} : timeDetails;

            return (
              <>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(days).padStart(2, "0")}
                    </div>
                    <div className={styles.timeSquareTextBottom}>дней</div>
                  </div>
                </div>
                <div className={styles.spaceDots}>:</div>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(hours).padStart(2, "0")}
                    </div>
                    <div className={styles.timeSquareTextBottom}>часов</div>
                  </div>
                </div>
                <div className={styles.spaceDots}>:</div>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(minutes).padStart(2, "0")}
                    </div>
                    <div className={styles.timeSquareTextBottom}>минут</div>
                  </div>
                </div>
                <div className={styles.spaceDots}>:</div>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(seconds).padStart(2, "0")}
                    </div>
                    <div className={styles.timeSquareTextBottom}>секунд</div>
                  </div>
                </div>
              </>
            );
          }}
        </TimeDisplay>
      </div>

      <div className={styles.rulesContainer}>
        <div className={styles.leftPart}>
          <div className={styles.cost}>
            {giveaway.enter_price.map((price, index) => (
              <div key={index}>
                <div
                  className={
                    price.type === "DC" ? styles.DCCost : styles.starsCost
                  }
                >
                  <div>
                    {price.amount} {price.type === "DC" ? "DC" : ""}
                  </div>
                  <img
                    src={price.type === "DC" ? dreamcoinLogo : star}
                    alt=""
                  />
                </div>
                {index < giveaway.enter_price.length - 1 && (
                  <div className={styles.slash}>/</div>
                )}
              </div>
            ))}
          </div>
          <div className={styles.costDescription}>Стоимость участия</div>
        </div>
        <div className={styles.rightPart}>
          <div className={styles.participants}>
            <div className={styles.participantsWrapper}>
              <div>{giveaway.total_participants}</div>
              <img src={usersLogo} alt="" />
            </div>
          </div>
          <div className={styles.participantsDescription}>
            Количество участников
          </div>
        </div>
      </div>

      {giveaway.status === "winner_selection" ? (
        <>
          <div className={styles.winnerSelection}>
            <button
              className={styles.watchBtn}
              onClick={() =>
                tg.openTelegramLink("https://t.me/+fnhiF2p_6oVhMGJi")
              }
            >
              Смотреть трансляцию
            </button>
          </div>
        </>
      ) : (
        <>
          {giveaway.status === "active" &&
          (giveaway as GiveawayActive).coupons_purchased_dc +
            (giveaway as GiveawayActive).coupons_purchased_star ===
            0 ? (
            ""
          ) : (
            <div className={styles.couponsContainer}>
              <div>Участвуешь с</div>
              <div className={styles.couponsWrapper}>
                <div>
                  {giveaway.status === "active" &&
                    (giveaway as GiveawayActive).coupons_purchased_dc +
                      (giveaway as GiveawayActive).coupons_purchased_star}
                </div>
                <img src={couponLogo} alt="" />
              </div>
            </div>
          )}

          <div className={styles.buttonsContainer}>
            {giveaway.enter_price.map((price, index) => (
              <button
                key={index}
                disabled={
                  price.type === "DC" &&
                  giveaway.status === "active" &&
                  (giveaway as GiveawayActive).coupons_purchased_dc >= 5
                }
                className={
                  price.type === "DC" ? styles.leftBtn : styles.rightBtn
                }
                onClick={
                  price.type === "DC" ? handleOpenDCModal : handleOpenStarModal
                }
              >
                <div>
                  {giveaway.status === "active" &&
                  (giveaway as GiveawayActive).coupons_purchased_dc +
                    (giveaway as GiveawayActive).coupons_purchased_star ===
                    0
                    ? "Участвовать за"
                    : "Докупить за"}
                </div>
                <img
                  className={styles.btnLogos}
                  src={price.type === "DC" ? dreamcoinLogo : star}
                  alt=""
                />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ActiveGiveawayInfo;
